export default __webpack_public_path__ + "static/media/honda-icons.037086bf.eot";